import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";
interface Props {
  company: server.dto.Company
}

const VisitingAddress = ({ company }: Props) => {
  return <div>
    <div>{company.name}</div>
    <FormattedAddress address={company.address} />
  </div>
};

export default VisitingAddress;